export default __webpack_public_path__ + "static/media/homepageback.b7ab004f.png";